import type { PropsWithChildren } from "react";
import { useCallback, useMemo, useState } from "react";

import { FilterSettingsContext, type FilterType } from "./FilterSettingsContext";

export const FilterSettingsProvider = ({ children }: PropsWithChildren) => {
  const [type, setType] = useState<FilterType | undefined>();
  const [tags, setTags] = useState<string[]>([]);

  const reset = useCallback(() => {
    setType(undefined);
    setTags([]);
  }, []);

  const value = useMemo(() => ({ type, setType, tags, setTags, reset }), [reset, tags, type]);

  return <FilterSettingsContext.Provider value={value}>{children}</FilterSettingsContext.Provider>;
};
